import ProjectApp from "@project/ProjectApp";
import App from "@/App";
import { TenantProvider } from "@/context/TenantContext";
import { useLocation } from "react-router-dom";

const TENANT_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isPlatformRoute(pathname: string) {
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  return Boolean(firstSegment && TENANT_UUID.test(firstSegment));
}

export default function AppRouter() {
  const { pathname } = useLocation();

  if (isPlatformRoute(pathname)) {
    return (
      <TenantProvider>
        <App />
      </TenantProvider>
    );
  }

  return <ProjectApp />;
}
